import {Button, styled, TextField} from "@mui/material";
import {theme} from "../../../../theme";

export const StyledTextField = styled(TextField)`
    width: 100%;
    max-width: 550px;
`;

export const StyledAvatarButton = styled(Button)`
    border: none !important;
    color: ${theme.palette.secondary.main} !important;
    font-weight: ${theme.typography.button} !important;
    font-size: ${theme.typography.button} !important;
    width: max-content !important;
    margin-bottom: 16px !important;

    @media (min-width: 960px) {
        margin-bottom: 0 !important;
    }
`;

export const ResetAvatarButton = styled(Button)`
    position: absolute !important;
    top: 0;
    right: 0;
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 50% !important;
    background-color: ${({ theme }) => theme.palette.background.paper} !important;
    color: ${({ theme }) => theme.palette.primary.main} !important;
    border: 1px solid ${({ theme }) => theme.palette.primary.main} !important;
    font-weight: ${({ theme }) => theme.typography.fontWeightBold} !important;
    font-size: ${({ theme }) => theme.typography.body2}  !important;
    padding: 0;
    z-index: 10;
    transform: translate(50%, -50%);
    
    &:hover {
        background-color: ${({ theme }) => theme.palette.secondary.main} !important;
        color: ${({ theme }) => theme.palette.primary.contrastText} !important;
    }
`;
